import { Injectable } from "@angular/core";

@Injectable({
    providedIn: "root",
})
export class DimmerConverterService {
    public defaultUnits = { input: "", output: "%" };

    getInputValue(level: string) {
        return "" + level === "100" ? 99 : parseInt(level, 10);
    }

    getOutputValue(level: string) {
        return "" + level === "99" ? 100 : parseInt(level, 10);
    }
}
